/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./bridgeConfigField.vue?vue&type=template&id=62e6529c&scoped=true"
import script from "./bridgeConfigField.vue?vue&type=script&lang=js"
export * from "./bridgeConfigField.vue?vue&type=script&lang=js"
import style0 from "./bridgeConfigField.vue?vue&type=style&index=0&id=62e6529c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62e6529c",
  null
  
)

export default component.exports